import { SITE_SECTION_TYPE_ID } from '@move-frontend/contentful';
import { IPathToPageIdMap } from '@move-frontend/contentful-routes';
import { getUrlForPage } from '../navigation/getUrlForPage';
import { IPageEntry } from '../contentful/types/IPage';
import { IGenericContentPageEntry } from '../contentful/types/IGenericContentPageEntry';
import { CUSTOM_PAGES_CONTAINER_TYPE_ID } from '../contentful/constants';

export function getParentLink(
	page: IGenericContentPageEntry | IPageEntry,
	pathToPageIdMap: IPathToPageIdMap,
): string {
	if (!page) {
		return '';
	}
	if (page.fields.parent?.contentType === SITE_SECTION_TYPE_ID) {
		return `/${page.fields.parent.fields.slug ?? ''}` || '';
	}
	if (
		!page.fields.parent ||
		page.fields.parent.contentType === CUSTOM_PAGES_CONTAINER_TYPE_ID
	)
		return '/';
	return getUrlForPage(pathToPageIdMap, page.fields.parent?.fields.id) || '';
}
